import React from "react";
import {
  Button as ButtonRaw,
  Modal as ModalRaw,
  colors,
  spacing,
  typography,
} from "../../../design-system";

const Button = ButtonRaw as any;
const Modal = ModalRaw as any;
interface ConfirmActionModalProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  processingLabel: string;
  processing: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function ConfirmActionModal({
  open,
  title,
  message,
  confirmLabel,
  processingLabel,
  processing,
  onCancel,
  onConfirm,
}: ConfirmActionModalProps) {
  return (
    <Modal
      isOpen={open}
      onClose={() => !processing && onCancel()}
      title={title}
    >
      <p
        style={{
          ...typography.body,
          color: colors.textSecondary,
          margin: "0 0 " + spacing[5] + "px",
        }}
      >
        {message}
      </p>
      <div
        style={{
          display: "flex",
          gap: spacing[2],
          justifyContent: "flex-end",
        }}
      >
        <Button variant="ghost" onClick={onCancel} disabled={processing}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm} disabled={processing}>
          {processing ? processingLabel : confirmLabel}
        </Button>
      </div>
    </Modal>
  );
}